// extracted by mini-css-extract-plugin
export var resume = "CreateResume-module--resume--1qMan";
export var backdrop = "CreateResume-module--backdrop--2OAKV";
export var page = "CreateResume-module--page--3C_cN";
export var meta = "CreateResume-module--meta--2F43z";